module.exports = __webpack_public_path__ + "img/5.bbd28855.jpg";